import React, { useEffect, useState } from "react";
import { Avatar, Badge, Dropdown, Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import gridSvg from "../assets/svg/grid.svg"; 
import leaveSvg from "../assets/svg/svg54.svg"; 
import leaveApprovalSvg from "../assets/svg/svg75.svg"; 
import reportSvg from "../assets/svg/svg58.svg"; 
import passwordSvg from "../assets/svg/svg76.svg"; 
import shiftSvg from "../assets/svg/shiftSvg.svg";

const menuData = [
  // {
  //   mnId: "1",
  //   mnLink: "dashboard-main",
  //   mnName: "dashboard",
  //   mnOwner: "ALL",
  //   mnParentId: null,
  //   mnIcons: null,
  //   children: [],
  // },
  {
    mnId: "2",
    mnLink: "leave-applications-list",
    mnName: "Leave Applications",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "leaveSvg",
    children: [],
  },
  
  {
    mnId: "3",
    mnLink: "leave-approvals",
    mnName: "Approvals",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "leaveApprovalSvg",
    children: [],
  },
  {
    mnId: "4",
    mnLink: "payslip-reports",
    mnName: "Payslips",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "reportSvg",
    children: [],
  },
  {
    mnId: "6",
    mnLink: "shift-request",
    mnName: "Shift Request",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "shiftSvg",
    children: [],
  }, 
  {
    mnId: "4",
    mnLink: "password-update",
    mnName: "Update Password",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "passwordSvg",
    children: [],
  },
  
 
  
];

const icons = {
  gridSvg, 
  leaveSvg,
  leaveApprovalSvg,
  reportSvg,
  passwordSvg,
  shiftSvg
};
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

export default function SideBarOpen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { sideMenuCollapsed, resellerId } = useSelector(
    (state) => state.global
  );
  const { user } = useSelector((state) => state.auth);

  const generateMenuItems = (menuData) => {
    if (user?.changePassword === true || user?.changePassword === null) {
      return [];
    }
    const mapItems = (items, isChild) => {
      return items?.map((item) => {
        const iconSrc = icons[item?.mnIcons] || gridSvg;
        return getItem(
          item?.mnName.charAt(0).toUpperCase() + item?.mnName.slice(1),
          item?.mnLink,
          !isChild ? <img src={iconSrc} alt={item?.mnIcons} /> : null,
          item?.children && item?.children?.length > 0
            ? mapItems(item?.children, true)
            : null
        );
      });
    };
    if (!menuData || menuData?.length === 0) {
      return [];
    }

    return mapItems(menuData);
  };
  const items = [
    ...generateMenuItems(menuData),

    {
      type: "divider",
    },
  ];

  const handleNavigation = (e) => {
    navigate(e.key);
  };

  const defaultOpenKeys = items
    .filter((item) => item?.mnName === "Personnel")
    .map((item) => item?.key);

  const defaultSelectedKeys = items
    .filter((item) => item?.mnName === "Dashboard")
    .map((item) => item?.key);

  const [openKeys, setOpenKeys] = useState([]);
  const handleOpenChange = (keys) => {
    const latestOpenKey = keys.length ? keys[keys.length - 1] : "";
    setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  };

  useEffect(() => {}, [sideMenuCollapsed]);

  return (
    <div
      style={{
        borderInlineEnd: "1px solid rgba(5, 5, 5, 0.06)",
        position: "sticky",
        top: 0,
      }}
      className="lg:flex hidden flex-col min-h-[90vh] h-full overflow-y-scroll max-w-[256px] w-full bg-[#f4f5f7]  mr-5 custom-scrollbar"
    >
      {items?.length > 0 ? (
        <Menu
          onClick={handleNavigation}
          style={{
            width: 256,
          }}
          className="overflow-y-scroll side-bar-scroll"
          defaultSelectedKeys={defaultSelectedKeys}
          defaultOpenKeys={defaultOpenKeys}
          mode="inline"
          items={items}
          theme="dark"
          inlineCollapsed={sideMenuCollapsed}
          openKeys={openKeys}
          onOpenChange={handleOpenChange}
        />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}
